








































  import { HistoryQuery as HistoryQueryModel } from '@empathyco/x-types';
  import { Component, Mixins, Prop } from 'vue-property-decorator';
  import { Getter } from '../../../components/decorators/store.decorators';
  import Highlight from '../../../components/highlight.vue';
  import BaseSuggestion from '../../../components/suggestions/base-suggestion.vue';
  import { xComponentMixin } from '../../../components/x-component.mixin';
  import { XEventsTypes } from '../../../wiring/events.types';
  import { historyQueriesXModule } from '../x-module';
  import { dynamicPropsMixin } from '../../../components/dynamic-props.mixin';
  import RemoveHistoryQuery from './remove-history-query.vue';

  /**
   * This component renders a history query suggestion combining two buttons: one for selecting this
   * suggestion as the search query, and another one to remove this query suggestion from the
   * history queries.
   *
   * @public
   */
  @Component({
    mixins: [xComponentMixin(historyQueriesXModule)],
    components: { Highlight, RemoveHistoryQuery, BaseSuggestion }
  })
  export default class HistoryQuery extends Mixins(
    dynamicPropsMixin(['removeButtonClass', 'suggestionClass'])
  ) {
    /**
     * The history query suggestion to render.
     *
     * @public
     */
    @Prop({ required: true })
    protected suggestion!: HistoryQueryModel;

    /**
     * The normalized query of the history-queries module.
     *
     * @internal
     */
    @Getter('historyQueries', 'normalizedQuery')
    public query!: string;

    /**
     * The list of events that are going to be emitted when the suggestion button is pressed.
     *
     * @internal
     * @returns The {@link XEvent} to emit.
     */
    protected get suggestionSelectedEvents(): Partial<XEventsTypes> {
      return {
        UserSelectedAHistoryQuery: this.suggestion
      };
    }
  }
